
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/[videoId]/[...slug]",
      function () {
        return require("private-next-pages/video/[videoId]/[...slug].tsx");
      }
    ]);
  